module.exports = __webpack_public_path__ + "assets/slike/plamen.b571248e011c7daa3e33ded18bd7f544.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/slike/plamen.gif
// module id = 34
// module chunks = 0